/** Foundation · Sequence — preferenza: cosa fare dopo aver completato un soggetto. */
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function SequenceModeSelect({ value, onChange, disabled, label, returnValue = "return", returnLabel, nextLabel = "Passa automaticamente al successivo", "data-testid": testid = "sequence-mode-select" }) {
  const options = [
    { value: "ask", label: "Chiedi sempre" },
    { value: "auto", label: nextLabel },
    { value: returnValue, label: returnLabel },
  ];
  return (
    <div>
      <Label>{label}</Label>
      <Select value={options.some((o) => o.value === value) ? value : "ask"} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger data-testid={testid} aria-label={label}><SelectValue /></SelectTrigger>
        <SelectContent>
          {options.map((o) => <SelectItem key={o.value} value={o.value} data-testid={`${testid}-option-${o.value}`}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export default SequenceModeSelect;
